import "core-js/modules/es.object.to-string.js";
import { getUnreadMsgSize } from '@/api/msg.js';
var state = {
  unreadSize: 0
};
var mutations = {
  SET_SIZE: function SET_SIZE(state, unreadSize) {
    state.unreadSize = unreadSize;
  },
  SET_DECREMENT: function SET_DECREMENT(state) {
    state.unreadSize--;
    if (state.unreadSize < 0) {
      state.unreadSize = 0;
    }
  }
};
var actions = {
  initUnreadMsgSize: function initUnreadMsgSize(_ref) {
    var dispatch = _ref.dispatch,
      commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      getUnreadMsgSize({
        platformType: 'SALES',
        page: 1,
        limit: 10
      }).then(function (data) {
        console.log("unread msg size", data);
        if (data.code == 200) {
          commit('SET_SIZE', data.data.unreaded);
          resolve();
        } else {
          console.log(data.message);
          reject(data.message);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  decrement: function decrement(_ref2) {
    var commit = _ref2.commit;
    commit('SET_DECREMENT');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};